<template>
  <div class="error_container">
    <div class="error_top">
      <TopCard ref="TopCardRef"
               text="错题详情">
      </TopCard>

    </div>
    <div class="error_bottom">
      <div class="error_left"
           id="errorLeft"
           ref="errorLeftRef">
        <leftTopic @showPost="showPost"
                   :topic="questionInfo"
                   @cancel="closeWindow"
                   @update="getTopicInfo"
                   @biji="biji" />
      </div>
      <button class="line_move"
              id="moveLine"
              title="鼠标按住拖动"
              @mousedown="moveAble"></button>

      <div class="error_right">
        <Map ref="mapRef"
             @setFloatData="setFloatData" />
        <!-- </div> -->

      </div>
      <div class="float_window"
           ref="floatWindowRef">
        <div class="move_box"
             @mousedown="windowCanMove"></div>
        <FloatWindow v-if="showWindow"
                     @close="closeWindow"
                     ref="windowRef" />
      </div>

    </div>
    <PostForm ref="FormRef"
              title='发帖'
              type='1'
              @submit="submit"
              @cancel='cancel'
              :isDisable='true' />
    <Biji ref="bijiRef"
          @updateInfo="getTopicInfo" />
  </div>

</template>

<script setup>
import TopCard from '@/views/components/top_card/index.vue'
import leftTopic from './leftTopic.vue'
import Map from './map.vue'
import FloatWindow from './floatWindow.vue'
import PostForm from '@/views/dayi/components/form.vue'
import { addPost } from '@/api/post.js'
import { nextTick, onMounted, ref, reactive, onUnmounted } from 'vue'
import { getErrorInfo, getInfo, getKnowledgeInfo,getCapability } from '@/api/errorBook.js'
import { useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import Biji from './biji.vue'

let route = useRoute()
let showWindow = ref(false)
let mapRef = ref()
let subject_id = ref('')

onMounted(() => {
  getTopicInfo()
  nextTick(() => {
    // mapRef.value.init()
    document.addEventListener('mousemove', moveDiv)
    document.addEventListener('mousemove', moveWindow)
    document.addEventListener('mouseup', moveDisAble)
    document.addEventListener('mouseup', winDisMove)
  })

  subject_id.value = route.query.subject_id
})


// 鼠标拖到调整作用大小宽度
let isMove = ref(false)
const moveAble = (bool) => {
  isMove.value = true
  document.onselectstart = function () {
    return false
  }
}
const moveDisAble = (bool) => {
  isMove.value = false
  document.onselectstart = function () {
    return true
  }
}
let errorLeftRef = ref()
const moveDiv = (e) => {
  if (isMove.value) {
    let divWidth = errorLeftRef.value.clientWidth
    let screenWidth = document.body.clientWidth
    if ((screenWidth - divWidth <= 375 && screenWidth - e.clientX <= 375) || (divWidth <= 514 && e.clientX <= 514)) {
      return
    }
    errorLeftRef.value.style.width = e.clientX + 'px'
  }
}

let questionInfo = reactive({ volist: [] })
// 获取收藏题目详情
const getTopicInfo = async (id) => {
  let dataId = ''
  console.log('id', id);

  if (id == undefined) {
    dataId = route.query.id
  } else {
    dataId = id
  }
  if (route.query.type == 1) {
    const { data } = await getErrorInfo({ user_paper_detail_id: dataId })
    for (const key in data) {
      questionInfo[key] = data[key]
    }
  } else {
    const { data } = await getInfo({ question_id: dataId })
    for (const key in data) {
      questionInfo[key] = data[key]
    }
  }

  nextTick(() => {
    getMapList()
  })

}
const getMapList = () => {
  let list = {
    id: 'topic_root',
    topic: '题目',
    children: []
  }
  
  if (questionInfo.question_knowledge && questionInfo.question_knowledge.length > 0) {
    // list.children.push({
      list.children.push( {
      id: 'knowledge_root',
      topic: '考点',
      children: flatKnowledgeList(questionInfo.question_knowledge)
    })
  }
  if (questionInfo.capability_type && questionInfo.capability_type.length > 0) {
    list.children.push({
      id: 'capability',
      topic: '核心素养',
      children: flatCapabilityType1List(questionInfo.capability_type)
    })
  }

  mapRef.value.init(list)
}


//处理知识点数据
const flatKnowledgeList = (arr) => {
  let list = []
  arr.forEach(item => {
    let obj = {
      id: item.knowledge_id,
      type: 'knowledge',
      topic: item.knowledge_desc + '<span style="font-family: iconfont;font-size:24rem;vertical-align: bottom;line-height: 18px;margin-right: -10px ">&#xe604;</span>',
      // topic: item.knowledge_desc,
      parentId: item.knowledge_parent_id,
      children: []
    }
    if (item.child && item.child.length) {
      obj.children = flatKnowledgeList(item.child)
    }
    list.push(obj)
  });
  return list;
}
//处理核心素养数据
const flatCapabilityType1List = (arr) => {
  let list = []
  arr.forEach(item => {
    let obj = {
      id: item.capability_id,
      type: 'capability',
      topic: item.capability_name + '<span style="font-family: iconfont;font-size:26rem;vertical-align: -14%;line-height: 22rem;margin-right: -6px ">&#xe604;</span>',
      parentId: item.capability_parent_id,
      children: []
    }
    if (item.child && item.child.length) {
      obj.children = flatCapabilityType1List(item.child)
    }
    list.push(obj)
  });
  return list;
}



  let sessionNodeList = ref([])
let floatData = ref([])
let windowRef = ref()
let floatWindowRef = ref()

let winMove = ref(false)
let oX = ref(0)
let oY = ref(0)
const windowCanMove = (e) => {
  oX.value = e.pageX - floatWindowRef.value.offsetLeft
  oY.value = e.pageY - floatWindowRef.value.offsetTop
  winMove.value = true
  document.onselectstart = function () {
    return false
  }
}
const winDisMove = () => {
  winMove.value = false
  document.onselectstart = function () {
    return true
  }
}
const moveWindow = (e) => {
  if (winMove.value) {
    let offsetBottom = document.body.clientHeight - (floatWindowRef.value.offsetTop + floatWindowRef.value.offsetHeight + oY.value)
    let offsetRight = document.body.clientWidth - (floatWindowRef.value.offsetLeft + floatWindowRef.value.clientWidth)
    // 上下边界限制
    if ((floatWindowRef.value.offsetTop > 0 || e.pageY > oY.value) && (offsetBottom > 0 || e.pageY < document.body.clientHeight - floatWindowRef.value.offsetHeight)) {
      floatWindowRef.value.style.top = e.pageY - oY.value + 'px'
    }
    if ((floatWindowRef.value.offsetLeft > 0 || e.pageX > oX.value) && (offsetRight > 0 || e.pageX < document.body.clientWidth - floatWindowRef.value.offsetWidth)) {
      floatWindowRef.value.style.left = e.pageX - oX.value + 'px'
    }
  }
}

let nodeId = ref()
// 设置浮窗数据
const setFloatData = async (id, parentId, type) => {
  if (id == 'knowledge_root' || id == 'topic_root' || id == 'capability') return
  if (nodeId.value == id && showWindow.value) return
  nodeId.value = id
  showWindow.value = true
  let node = isSessionNode(type, id) //查找节点有无缓存
  if (node.id) {
    floatData.value = node.data
    nextTick(() => {
      windowRef.value.windowData = node.data
    })
    return
  }
  let form
  if (type == 'knowledge') {
    const { data } = await getKnowledgeInfo({
      knowledge_id: id
    })
    form = {
      type: 'knowledge',
      knowledge_id: data.knowledge_id,
      subjectId: data.subject_id,
      title: data.knowledge_desc,//标题
      star: data.knowledge_point_star ? data.knowledge_point_star : 0,//知识点星级
      time: data.paper_time,//做卷时间
      score: data.score,//得分率
      count: data.count,
      video_list: data.video_list//关联的考点视频
    }
    // console.log(data)
    floatData.value = form
    nextTick(() => {
      windowRef.value.windowData = form
    })
    setSessionNode('knowledge', id, form)
  }
  console.log('type', type);
  
  if (type == 'capability') {
    const { data } = await getCapability({
      capability_id: id
    })
    form = {
      type: 'capability',
          capability_id: data.capability_id,
          subjectId: data.subject_id,
          title: data.capability_name,//标题
          time: data.paper_time,//做卷时间
          score: data.score,//得分率
          count: data.count,
          video_list: data.video_list//关联的考点视频
    }
  
    floatData.value = form
    nextTick(() => {
      windowRef.value.windowData = form
    })
    setSessionNode('capability', id, form)
  }
}

const isSessionNode = (type, id) => {
  sessionNodeList.value = JSON.parse(window.sessionStorage.getItem("sessionNodeList")) || []
  if (!sessionNodeList.value.length) return false
  let node = sessionNodeList.value.find(item => item.type == type && item.id == id
  )

  if (!node) { return false }
  return node
}
const setSessionNode = (type, id, data) => {
  sessionNodeList.value.push({
    type: type,
    id,
    data
  })
  window.sessionStorage.setItem("sessionNodeList", JSON.stringify(sessionNodeList.value))
}

onUnmounted(() => {
  window.sessionStorage.removeItem("sessionNodeList")
})

// 思维导图弹窗
const closeWindow = () => {
  showWindow.value = false
  mapRef.value.cancelSelected()
}
let FormRef = ref()
let bijiRef = ref()
const showPost = () => {
  let form = {
    discuss_title: '',
    discuss_content: '',
    board_id: Number(subject_id.value),
    // question_id: rands(Number(topic.value.question_id)),
    question_id: Number(questionInfo.question_id),

    discuss_image: []
  }
  nextTick(() => {
    FormRef.value.form = form
    FormRef.value.dialogVisible = true
  })
}

// 点击笔记按钮
const biji = () => {
  // bijiRef.value.setData(topic.value)
  bijiRef.value.setData(questionInfo)

}

//发帖弹窗》提交
const submit = async () => {
  const { status } = await addPost(
    FormRef.value.form1
  )
  if (status == 200) {
    message.success('发帖成功')
    cancel()
  }

}
const cancel = () => {
  FormRef.value.dialogVisible = false
}


</script>

<style lang="scss" scoped>
.error_container {
  background: #f5f5f5;
  .error_bottom {
    height: calc(100vh - 100rem);
    display: flex;
    position: relative;
  }
}
.line_move {
  width: 3px;
  padding: 0;
  border: 0;
  background: #e6e6e6;
  cursor: col-resize;
}
.error_left {
  background: #fff;
  width: 50%;
  height: 100%;
  overflow: auto;
}
.error_right {
  flex: 1;
  margin-left: 24px;
}
.float_window {
  position: absolute;
  left: 52%;
  top: 24px;
  z-index: 5;
  .move_box {
    position: absolute;
    // background: #333;
    left: 0;
    width: 100%;
    border-radius: 20rem 20rem 0 0;
    height: 20rem;
    cursor: move;
  }
}
// .map_wrap {
//   height: calc(100vh - 100rem);
// }
</style>